<!--
    课程分享-课时编辑-课时组件
    作用：单个组件
    功能：展示子组件信息
    说明：版本3.0
-->
<template>
    <div class="item-wrapper">
      <div class="top">
        <div class="left">
          <div class="number">{{info.sort + 1}}</div>
        </div>
        <div class="right">
          <div class="txt elps">{{info.result.name}}</div>
          <div class="date">{{info.created_at}}</div>
        </div>
      </div>
      <div class="bottom">
        <div class="left">
          <el-checkbox v-model="checked" @change="handlerChange"/>
        </div>
        <div class="right">
          <i class="iconfont icon-delete" @click="remove"></i>
          <i class="iconfont icon-edit" @click="edit"></i>
          <!-- <i class="iconfont icon-switch" @click="move"></i> -->
        </div>
      </div>
    </div>
</template>
<script>
export default {
  name: 'classItem',
  props: {
    info: Object,
    isClose: Boolean
  },
  watch: {
    isClose (val) {
      this.checked = false
    }
  },
  data () {
    return {
      checked: false
    }
  },
  methods: {
    remove () {
      this.$emit('remove')
    },
    edit () {
      this.$emit('edit')
    },
    move () {
      this.$emit('move')
    },
    handlerChange (val) {
      this.$emit('change', {
        state: val,
        id: this.info.id
      })
    },
    isCloseCheck () {
      this.checked = false
    }
  }
}
</script>
<style lang="scss" scoped>
.item-wrapper{
  width: 246px;
  height: 136px;
  margin: 10px;
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid #E9E9E9;
  cursor: grab;
  .top{
    flex:1;
    padding: 20px 20px 0 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .left{
      flex:0 0 50px;
      width: 50px;
      .number{
      width: 24px;
      height: 24px;
      line-height: 24px;
      color: #fff;
      text-align: center;
      background: #C6C9CE;
      border-radius: 50%;
      }
    }
    .right{
      width: 164px;
      .txt{
        width: 100%;
         font-size: 16px;
         color: #000;
      }
      .date{
        padding-top: 15px;
        font-size: 14px;
        color: rgba($color: #000000, $alpha: 0.45);
      }
    }
  }
  .bottom{
    flex:0 0 40px;
    height: 40px;
    padding: 0 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #F5F7FA;
    border-top: 1px solid #E9E9E9;
    .right{
      .iconfont{
        color: #a8a9ac;
        cursor: pointer;
        font-size: 18px;
        margin-left: 10px;
        &:hover{
          color: #FF7838
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/CourseOn/editClassHours/components/classHours/classItem.vue